import React, { useEffect, useState, useRef, useContext } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { blacklist } from "../../Hooks/blacklist";
import { useHistory } from "react-router-dom";
import { useQueryString } from "../../Hooks/useQueryString";
import { useDataIngestion } from "../../Hooks/useDataIngestion";
import { useSignature } from "../../Hooks/useSignature";
import { useUpdateMilestone } from "../../Hooks/useUpdateMilestone";
import { useAddressApi } from "../../Hooks/useAddressApi";
import { usePageLoad } from "../../Hooks/usePageLoad";
import { getPageName } from "../../Constants/PageNames";
import QueryStringContext from "../../Contexts/QueryString";
import VisitorParamsContext from "../../Contexts/VisitorParams";
import * as EnvConstants from "../../Constants/EnvConstants";
import LenderSection from "../Includes/Layouts/UFC_DC_RF_V1/LenderSection";
import Loader from "../Includes/Layouts/UFC_DC_RF_V1/Loader";
import PersonalDetails from "../Includes/Layouts/UFC_DC_RF_V1/PersonalDetails";
import GtmDataLayer from "../../Utility/GtmDataLayer";
import TMSClaimDocModal from "../Includes/Layouts/UFC_DC_RF_V1/TMSClaimDocModal";
import CHClaimDocModal from "../Includes/Layouts/UFC_DC_RF_V1/CHClaimDocModal";
import Loa from "../Includes/Layouts/UFC_DC_RF_V1/Loa";
import Tob from "../Includes/Layouts/UFC_DC_RF_V1/Tob";
import Decl from "../Includes/Layouts/UFC_DC_RF_V1/Decl";
import Vq from "../Includes/Layouts/UFC_DC_RF_V1/Vq";
import Dsar from "../Includes/Layouts/UFC_DC_RF_V1/Dsar";
import MockLoaModal from "../Includes/Layouts/UFC_DC_RF_V1/UFCDCRFV1_LoaModal";
import ChcWelcomeModal from "../Includes/Layouts/UFC_DC_RF_V1/ChcWelcomeModal";
import ChcLetterofAuthencityModal from "../Includes/Layouts/UFC_DC_RF_V1/ChcLetterofAuthencityModal";
import CHC_TOB from "../Includes/Layouts/UFC_DC_RF_V1/CHC_TOB";
import GenerateDynamicFollowUpURL from "../../Utility/GenerateDynamicFollowUpURL";

const Form_UFC_DC_RF_V1 = () => {
  const formMethods = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {},
    resolver: undefined,
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: true,
  });
  const {
    register,
    errors,
    trigger,
    setError,
    clearErrors,
    getValues,
    watch,
    handleSubmit,
  } = formMethods;

  const { updateMilestone } = useUpdateMilestone();
  const { saveSignature } = useSignature();
  const { formDataIngestion } = useDataIngestion();
  const { visitorParameters } = useContext(VisitorParamsContext);
  const [showLenderSection, setShowLenderSection] = useState("show");
  const [showPersonalDetails, setShowPersonalDetails] = useState(false);
  const splitForm = useRef(null);
  const [showLoader, setShowLoader] = useState("hide");
  const [signatureDataURL, setSignatureDataURL] = useState("");
  const [blacklisted, setBlacklisted] = useState([]);
  const field = "pid";
  const { getBlacklist } = blacklist();
  const history = useHistory();
  const { queryString } = useContext(QueryStringContext);
  const [f_name, setF_name] = useState("");
  const [selectedBank, setSelectedBank] = useState([]);
  const [estimatedRefund, setEstimatedRefund] = useState("");
  const [unaffordableRefund, setUnaffordableRefund] = useState("");
  const [agreement, setAgreement] = useState(true);
  const signPadRef = useRef();
  const { savePageLoad, calledOnce } = usePageLoad();
  const splitName = localStorage.getItem("split_name");
  const [previousAddressData, setPreviousAddressData] = useState({});
  const [showTMSClaimDoc, setShowTMSClaimDoc] = useState(false);
  const [showCHClaimDoc, setShowCHClaimDoc] = useState(false);
  const [showloa, setShowLoa] = useState(false);
  const [questionPdf, setQuestionPdf] = useState(false);
  const [showTOB, setShowTob] = useState(false);
  const [showDecl, setShowDecl] = useState(false);
  const [showDsar, setShowDsar] = useState(false);

  const [mockLoa, SetMockLoa] = useState(false);
  const [showChcWelcome, setShowChcWelcome] = useState(false);
  const [showChcLetterofAuthencity, setShowChcLetterofAuthencity] =
    useState(false);
  const [showChcTob, setShowChcTob] = useState(false);
  const form = splitForm.current;
  const values = getValues();
  const formDatas = values;
  // let UcFname = formData.txtFName.charAt(0).toUpperCase() + formData.txtFName.slice(1);
  // setF_name(UcFname);
  const [question118, SetQuestion118] = useState("");

  // const nextPage = "credit_quest_UFC_DC_RF_V1";
  const nextPage = "ThankyouOD_V2";

  const getUuid = () => {
    const visitorData = visitorParameters.visitor_parameters;
    if (visitorData != "") {
      var uuid = visitorData.uuid;
    } else {
      const query = new URLSearchParams(window.location.search);
      const query_uuid = query.get("uuid");
      const local_storage_uuid = localStorage.getItem("uuid");
      var uuid = query_uuid ? query_uuid : local_storage_uuid;
    }
    return uuid;
  };

  const uuid = getUuid();

  useEffect(() => {
    let responsesss = [];
    (async () => {
      const response = await getBlacklist();
      let dataLength = response.data.response.length;
      responsesss = response.data.response;

        if (dataLength > 0) {
        setBlacklisted(response.data.response);
        //blackListCheck(responsesss);
      }
      
    })();
  }, []);

  function blackListCheck(blacklistdata) {
  let blacklistFlag = false;
  const userValue = {
    ip: visitorParameters?.data?.ip_address,
    email: formDatas.txtEmail,
    phone: formDatas.txtPhone,
    domain: formDatas.emailDomain
  };

  blacklistdata.forEach((value) => {
    if (userValue.hasOwnProperty(value.type)) {
      const userFieldValue = userValue[value.type]?.toString() || '';
      const blacklistValue = value.value?.toString() || '';
      

      if (value.type === 'phone') {
        // Remove leading zeros for comparison
        const normalizedUserPhone = userFieldValue.replace(/^0+/, '');
        const normalizedBlacklistPhone = blacklistValue.replace(/^0+/, '');

        // Check if either phone contains the other (partial match)
        if (
          normalizedUserPhone.includes(normalizedBlacklistPhone) ||
          normalizedBlacklistPhone.includes(normalizedUserPhone)
        ) {
          blacklistFlag = true;
        }
      } 
      else if (blacklistValue === userFieldValue.toLowerCase()) {
        // Exact match for other fields
        blacklistFlag = true;
      }
    }
  });

  if (blacklistFlag) {
    window.scrollTo(0, 0);
    history.push(
      "/thankyou-bl?uuid=" + visitorParameters.visitor_parameters.uuid + "&split_name=" + splitName
    );
  }

  return blacklistFlag;
}

  useEffect(() => {
    if (signatureDataURL !== "") {
      formSubmit();
    }
  }, [signatureDataURL]);

  const formSubmit = async () => {
    if (formDatas.address1 !== "") {
      const txtUdprn = form["txtUdprn"].value;
      const txtDeliveryPointSuffix = form["txtDeliveryPointSuffix"].value;
      const txtPz_mailsort = form["txtPz_mailsort"].value;
      const txtStreet = form["txtStreet"].value;
      const txtAddress3 = form["txtAddress3"].value;
      const txtDistrict = form["txtDistrict"].value;

      formDatas.txtDistrict = txtDistrict;
      formDatas.txtAddress3 = txtAddress3;
      formDatas.txtUdprn = txtUdprn;
      formDatas.txtDeliveryPointSuffix = txtDeliveryPointSuffix;
      formDatas.txtPz_mailsort = txtPz_mailsort;
      formDatas.txtStreet = txtStreet;
    }

    formDatas.lender = [selectedBank[0]];
    formDatas.bud_lender = selectedBank[0].value;
    formDatas.lenders = selectedBank[0].value;
    formDatas.agreement = agreement;
    formDatas.question114 = estimatedRefund;
    formDatas.emailDomain = formDatas.txtEmail?.includes('@')
      ? '@' + formDatas.txtEmail.split('@')[1]?.toLowerCase()
      : '';

    //***previous_address ****/
    formDatas.previous_postcode = previousAddressData.postcode;
    formDatas.previous_address_line1 = previousAddressData.line_1;
    formDatas.previous_address_line2 = previousAddressData.line_2;
    formDatas.previous_address_line3 = previousAddressData.line_3;
    formDatas.previous_address_county = previousAddressData.county;
    formDatas.previous_address_town = previousAddressData.town;
    formDatas.previous_address_country = previousAddressData.country;
    formDatas.previous_district = previousAddressData.district;
    formDatas.previous_address_id = previousAddressData.prevAddressId;

    if (form["addressprev1"].value) {
      formDatas.previous_postcode = form["txtPrevPostCode"].value.toUpperCase();
      formDatas.previous_address_line1 = form["txtHouseNumberPrev"].value;
      formDatas.previous_address_line2 = form["txtAddress3prev"].value;
      formDatas.previous_address_line3 = form["txtAddress3Previous"]?.value;
      formDatas.previous_address_county = form["txtCountyprev"].value;
      formDatas.previous_address_town = form["txtTownprev"].value;
      formDatas.previous_address_country = form["txtCountryprev"].value;
      formDatas.previous_district = form["txtDistrictPrev"].value;
      formDatas.previous_address_id = form["addressprev1"].value;
    }

    formDatas.user_sign = signatureDataURL;
    formDatas.Previousname = form["txtPreName"].value;

    formDatas.page_name = "UFC_DC_RF_V1";
    formDatas.pCode_manual = form["pCode_EntryType"].value;
    if (
      visitorParameters.data !== null ||
      visitorParameters.data !== undefined
    ) {
      // let dobMonth = formDatas.DobMonth ? MonthNameArray[formDatas.DobMonth] : '';
      localStorage.setItem("fName", formDatas.txtFName);
      localStorage.setItem("lName", formDatas.txtLName);
      localStorage.setItem("pCode", formDatas.txtPostCode);
      localStorage.setItem("addressLine1", formDatas.txtHouseNumber);
      localStorage.setItem("dobYr", formDatas.DobYear);
      localStorage.setItem("dobMon", formDatas.DobMonth);
      localStorage.setItem("dobDy", formDatas.DobDay);
      localStorage.setItem("addressLine2", formDatas.txtAddress2);
      localStorage.setItem("postTown", formDatas.txtTown);
      localStorage.setItem("country", formDatas.txtCounty);
      localStorage.setItem("title", formDatas.lstSalutation);
      localStorage.setItem("addressLine3", formDatas.txtAddress3);
      localStorage.setItem("county", formDatas.txtCounty);
      localStorage.setItem(
        "district",
        formDatas.txtDistrict ? formDatas.txtDistrict : ""
      );
      let UcFname =
        formDatas.txtFName.charAt(0).toUpperCase() +
        formDatas.txtFName.slice(1);

      localStorage.setItem("UcFname", UcFname);

      localStorage.setItem("formData", JSON.stringify(formDatas));
      localStorage.setItem("queryString", queryString);

      if (signatureDataURL) {
        const formSUbmitResult =await formDataIngestion(
          visitorParameters.visitor_parameters,
          formDatas,
          "split_form_submit",
          "UFC_DC_RF_V1",
          queryString,
          visitorParameters.data
        );
        if(formSUbmitResult?.data?.status?.toLowerCase()==="success"){
          if(formSUbmitResult?.status == 200 && formSUbmitResult?.data?.isDuplicate) {
            // const flp_url = await GenerateDynamicFollowUpURL(formSUbmitResult?.data?.uuid, formSUbmitResult?.data?.token, formSUbmitResult?.data?.flp_path);
            const flp_url = `/${nextPage}?uuid=${visitorParameters.visitor_parameters.uuid}`;
            console.log("FLP URL", flp_url);
            
            localStorage.clear();
            history.push(flp_url);
  
          } else {

          const message_type = "signature_store";
          const response = await saveSignature(
            signatureDataURL,
            visitorParameters.visitor_parameters,
            formDatas,
            visitorParameters.data,
            queryString,
            message_type
          );
  
          if (response.data.status === "Success") {
            updateMilestone(
              visitorParameters.visitor_parameters.uuid,
              "lead",
              "live"
            );
            updateMilestone(
              visitorParameters.visitor_parameters.uuid,
              "signature",
              "live"
            );
            const data = {
              uuid,
              page_name: getPageName("personal"),
              status: "completed",
              source: "regular",
            };
  
            (async () => {
              await savePageLoad(
                visitorParameters.visitor_parameters,
                data,
                "visited_status",
                splitName,
                queryString,
                visitorParameters.data
              );
            })();

              pageChange();
            
          } 
        }
        }
      }
    } else {
      return "Fail";
    }
  };

  const pageChange = () => {
    let bl_res = false;
    if(blacklisted){
      bl_res = blackListCheck(blacklisted);
    }
    
  
   if (bl_res == false){
      if (queryString != null) {
        if (queryString.indexOf("&" + field + "=") !== -1) {
          if (EnvConstants.AppConversionPixel === "true") {
            history.push(`/fbpixel?split_name=UFC_DC_RF_V1&nextPage=${nextPage}`);
          } else {
            window.scrollTo(0, 0);
            GtmDataLayer({
              question: "contact information",
            });
            // history.push(
            //   `/creditcheck_UFC_DC_RF_V1?uuid=${visitorParameters.visitor_parameters.uuid}&nextPage=${nextPage}`
            // );
            history.push(
              `/${nextPage}?uuid=${visitorParameters.visitor_parameters.uuid}`
            );
          }
        } else {
          window.scrollTo(0, 0);
          GtmDataLayer({
            question: "contact information",
          });
          // history.push(
          //   `/creditcheck_UFC_DC_RF_V1?uuid=${visitorParameters.visitor_parameters.uuid}&nextPage=${nextPage}`
          // );
          history.push(
              `/${nextPage}?uuid=${visitorParameters.visitor_parameters.uuid}`
            );
        }
      } else {
        GtmDataLayer({
          question: "contact information",
        });
        window.scrollTo(0, 0);
        // history.push(
        //   `/creditcheck_UFC_DC_RF_V1?uuid=${visitorParameters.visitor_parameters.uuid}&nextPage=${nextPage}`
        // );
        history.push(
              `/${nextPage}?uuid=${visitorParameters.visitor_parameters.uuid}`
            );
      }
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const pageTop = window.pageYOffset;
      const pageBottom = pageTop + window.innerHeight;
      const tags = document.querySelectorAll(".fadein-eff");

      tags.forEach((tag) => {
        const tagTop = tag.getBoundingClientRect().top + pageTop;

        if (tagTop < pageBottom) {
          tag.classList.add("visible");
        } else {
          tag.classList.remove("visible");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <FormProvider {...formMethods}>
        <form
          ref={splitForm}
          name="split_form"
          id="user_form"
          method="POST"
          autoComplete="off"
        >
          <LenderSection
            setShowLenderSection={setShowLenderSection}
            showLenderSection={showLenderSection}
            setShowPersonalDetails={setShowPersonalDetails}
            setShowLoader={setShowLoader}
            setSelectedBank={setSelectedBank}
            uuid={uuid}
          />
          <Loader showLoader={showLoader} />

          <PersonalDetails
            show={showPersonalDetails}
            formSubmit={formSubmit}
            setPreviousAddressData={setPreviousAddressData}
            setAgreement={setAgreement}
            setSignatureDataURL={setSignatureDataURL}
            setShowTMSClaimDoc={setShowTMSClaimDoc}
            setShowCHClaimDoc={setShowCHClaimDoc}
            setShowLoa={setShowLoa}
            setQuestionPdf={setQuestionPdf}
            setShowTob={setShowTob}
            setShowDecl={setShowDecl}
            setShowDsar={setShowDsar}
            SetMockLoa={SetMockLoa}
            setShowChcWelcome={setShowChcWelcome}
            setShowChcLetterofAuthencity={setShowChcLetterofAuthencity}
            setShowChcTob={setShowChcTob}
            setEstimatedRefund={setEstimatedRefund}
          />
        </form>
      </FormProvider>
      {/* <div className="hide" > */}
      {/* {showTMSClaimDoc && (
          <TMSClaimDocModal setShowTMSClaimDoc={setShowTMSClaimDoc} />
        )} */}
      {showCHClaimDoc && (
        <CHClaimDocModal setShowCHClaimDoc={setShowCHClaimDoc} />
      )}

      {showloa && <Loa setShowLoa={setShowLoa} showloa={showloa} />}

      {questionPdf && (
        <Vq close={()=>setQuestionPdf(false)} />
      )}

      {showTOB && <Tob showTOB={showTOB} setShowTob={setShowTob} />}
      {showDecl && <Decl showDecl={showDecl} setShowDecl={setShowDecl} />}

      {showDsar && <Dsar showDsar={showDsar} setShowDsar={setShowDsar} />}

      {mockLoa && <MockLoaModal SetMockLoa={SetMockLoa} />}
      {showChcWelcome && (
        <ChcWelcomeModal setShowChcWelcome={setShowChcWelcome} />
      )}

      {showChcLetterofAuthencity && (
        <ChcLetterofAuthencityModal
          setShowChcLetterofAuthencity={setShowChcLetterofAuthencity}
        />
      )}

      {showChcTob && <CHC_TOB setShowChcTob={setShowChcTob} />}
      {/* </div> */}
    </>
  );
};

export default Form_UFC_DC_RF_V1;
